import { render } from "./UserProfileSurnameSvg.vue?vue&type=template&id=52bcef46"
import script from "./UserProfileSurnameSvg.vue?vue&type=script&lang=js"
export * from "./UserProfileSurnameSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__